<script>
  import { createEventDispatcher } from 'svelte'
  import Icon from 'smelte/src/components/Icon'
  import { ClassBuilder } from 'smelte/src/utils/classes'

  const classesDefault = "capitalize duration-100 text-gray-600 text-xs hover:text-black dark-hover:text-white p-3 font-normal text-right";

  export let classes = classesDefault;
  export let column = {}
  export let asc = false
  export let sortBy = false
  export let sortable = true
  export let editing = false

  const dispatch = createEventDispatcher()

  const cb = new ClassBuilder(classes, classesDefault);
  $: c = cb
    .flush()
    .add(classes, true, classesDefault)
    .add($$props.class)
    .get();
</script>


<style>
  .sort.asc {
    transform: rotate(180deg);
  }
  .sort {
    opacity: 1 !important;
  }
</style>

<div
  class={c}
  class:cursor-pointer={sortable || column.sortable}
  on:click={() => {
    if (column.sortable === false || !sortable) return
    dispatch("sort", column)

    editing = false
    asc = sortBy === column ? !asc : true
    sortBy = column
  }}
>
  <div class="flex items-center justify-end select-none">
    {#if sortable && column.sortable !== false && !column.iconAfter}
      <span class="sort" class:asc={!asc && sortBy === column}>
        <Icon small color="text-gray-400 dark:text-gray-100">arrow_downward</Icon>
      </span>
    {/if}
    <span class="flex-grow">{column.label || column.field}</span>
    {#if sortable && column.sortable !== false && !!column.iconAfter && sortBy === column}
      <span class="sort ml-1 mb-2">
        {#if !asc && sortBy === column}
          <Icon>keyboard_arrow_down</Icon>
        {:else}
          <Icon>keyboard_arrow_up</Icon>
        {/if}
      </span>
    {/if}
  </div>
</div>